import { render, staticRenderFns } from "./TabsComentario.vue?vue&type=template&id=7bc50cce&lang=html&"
import script from "./TabsComentario.vue?vue&type=script&lang=js&"
export * from "./TabsComentario.vue?vue&type=script&lang=js&"
import style0 from "./TabsComentario.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports